import React, { useState } from 'react';

const EXAMPLES = [
  {
    title: 'Bold and italic',
    sample: 'Install **v1.3.2** and *restart the app*.',
  },
  {
    title: 'Links',
    sample: 'Read the [wiki](https://wiki.fluoraplant.com/beta).',
    note: 'Links must start with http://, https://, or mailto:',
  },
  {
    title: 'Bullet lists',
    sample: '- Test WiFi commissioning\n- Test the new permissions window\n- Report any UI issues',
  },
  {
    title: 'Numbered lists',
    sample: '1. Update firmware\n2. Update the mobile app\n3. Start the test',
  },
  {
    title: 'Headings',
    sample: '## Before you start\nConfirm you are on the right versions.',
  },
  {
    title: 'Line breaks',
    sample: 'A single return stays in the same paragraph.\n\nA blank line starts a new one.',
  },
  {
    title: 'Inline code',
    sample: 'If you see `OTA failed`, reboot the device.',
  },
];

const MarkdownMark = () => (
  <svg className="markdown-help-mark" viewBox="0 0 208 128" aria-hidden="true">
    <rect width="198" height="118" x="5" y="5" rx="10" fill="none" stroke="currentColor" strokeWidth="10" />
    <path
      fill="currentColor"
      d="M30 98V30h20l20 25 20-25h20v68H90V59L70 84 50 59v39zm125 0l-40-40h25V30h30v28h25z"
    />
  </svg>
);

interface MarkdownHelpProps {
  htmlFor?: string;
  children: React.ReactNode;
}

const MarkdownHelp: React.FC<MarkdownHelpProps> = ({ htmlFor, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="markdown-help-label">
        <label htmlFor={htmlFor} className="form-label fw-bold mb-0">{children}</label>
        <button
          type="button"
          className="markdown-help-trigger"
          title="Markdown is supported"
          aria-label="Markdown is supported. Open formatting help."
          onClick={() => setOpen(true)}
        >
          <MarkdownMark />
        </button>
      </div>
      {open && (
        <div className="beta-leave-modal" role="dialog" aria-modal="true" aria-labelledby="markdown-help-title">
          <div className="beta-leave-modal-card beta-join-modal-card markdown-help-modal">
            <h2 id="markdown-help-title">Markdown</h2>
            <p className="text-muted mb-3">
              You can format this field with the examples below.
            </p>
            <div className="markdown-help-examples">
              {EXAMPLES.map((example) => (
                <article key={example.title} className="markdown-help-example">
                  <strong>{example.title}</strong>
                  {example.note ? <div className="text-muted small">{example.note}</div> : null}
                  <pre>{example.sample}</pre>
                </article>
              ))}
            </div>
            <div className="beta-leave-modal-actions">
              <button type="button" className="btn btn-primary" onClick={() => setOpen(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MarkdownHelp;
